{/* App Level Design Constants */ }
export const Default_Text_Color = "#1e66ab";

{/* Validation Constants */ }
export const Password_Regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
export const Name_Regex = /^[A-Za-z\s-]+$/;
export const Email_Regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const Alphanumeric_Regex = /^[a-zA-Z0-9\s-]+$/;
export const AlphanumericWithHyphenUnderscoreBlankSpace_Regex = /^[A-Za-z0-9\s_-]+$/;


{ /* Enums */ }
export enum EntityType {
  Client = 1,
  Project = 2,
  Proposal = 3,
  FeeStage = 4
}
export enum RoleMapping {
  "Admin" = 1,
  "Bid Coordinator" = 2,
  "Project Manager" = 3,
  "Assistant Project Manager" = 4,
}
export enum ForecastDisplayType {
  LiveDefinite = 1,
  LiveProposed = 2,
  OutStanding = 3,
  Historic = 4,
  ThirdPartyCost = 5,
}

export enum FormType {
  Project = 1,
  LiveDefinite,
  LiveProposed,
  ThirdPartyCost
}

export enum IFSType{
  IFSDefinite=1,
  IFSProposed=2,
  IFSThirdparty=3,
  Graph=4,
  IFSHistory=6,
  ChangePeriod = 7
}
export enum IFSHistoryType
{
  Definite=1,
  Proposed=2
}
//for Invoices

export enum InvoiceStatus
{
  Draft=1,
  Submitted=2,
  Approved=3,
  Rejected=4,
  Deleted=5
}
export enum InvoiceMode{
  Edit=1,
  View=0
}
export const DateFormat = "DD/MM/YYYY HH:mm";
 